// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"Input_inputContainer__3Jb7e","rightComponentContainer":"Input_rightComponentContainer__1qKrz"};